export default "/_next/static/images/49/resultsMobile-49536ded84a92003ccefd5c91d5707b1.jpg";